import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { renderComponent } from '@/utils';
import { getDisclosurePageConfig } from './config';
import { DisclosureType } from '@/config/enums';

/**
 * Disclosure Page
 * A common page component for displaying legal/disclosure documents
 * Uses URL path to determine which content to display:
 * - /disclosure/terms-of-use
 * - /disclosure/confirmation-release
 * - /disclosure/electronic-documents
 *
 * Based on Figma design: node-id=1140-195099
 * Uses config-driven rendering pattern
 */
const Disclosure = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const location = useLocation();

  // Extract type from pathname
  const pathParts = location.pathname.split('/');
  const type = pathParts[pathParts.length - 1];

  // Map URL path to DisclosureType enum
  const disclosureTypeMap: Record<string, DisclosureType> = {
    'terms-of-use': DisclosureType.TERMS_OF_USE,
    'confirmation-release': DisclosureType.CONFIRMATION_RELEASE,
    'electronic-documents': DisclosureType.ELECTRONIC_DOCUMENTS,
  };

  const disclosureType =
    disclosureTypeMap[type || ''] || DisclosureType.TERMS_OF_USE;

  const config = getDisclosurePageConfig(theme, t, disclosureType);

  return <>{renderComponent(config, 0, false)}</>;
};

export default Disclosure;
